import React, { useState } from "react";
import { InputWrapper } from "../components/input";
import LoginTopImage from "../images/loginTopImage.png";
import { Form, Row, Col, message, Button } from "antd";
import { StyledCheckbox } from "../components/input/CheckBox";
import { errorHandler } from "../utils/errorHandler";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { ButtonWrapper } from "../components/buttons";
import Cookies from "js-cookie";
import { login } from "../apis/generalApis";

const StyledContent = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .form-label {
    text-align: left;
    margin-bottom: 8px;
    font-size: 16px;
  }

  .card-wrapper {
    width: 448px;
    height: 512px;
    padding: 0 32px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }

  .banner-wrapper {
    textalign: left;
    position: relative;
    top: -80px;
    left: 0px;

    p {
      font-size: 16px;
      margin: 0;
      color: #000000a6;
    }
  }

  .forgot-password {
    margin-top: 16px;
    text-align: center;
    a {
      color: #1d194d;
    }
  }
`;

const LoginNew = () => {
  const history = useHistory();

  const [state, setState] = useState({
    email: "",
    password: "",
  });

  const handleLogin = async () => {
    try {
      if (state.email !== "" || state.password !== "") {
        let body = {
          email: state.email,
          password: state.password,
        };
        let response = await login("user-login", body);
        if (response.message != undefined) {
          message.error(response.message);
          return;
        }
        sessionStorage.setItem("user", JSON.stringify(response.data));
        window.location.pathname = "/services";
      }
      // else {
      //   message.error("incorrect email or password");
      // }
    } catch (err) {
      message.error("incorrect email or password");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  return (
    <StyledContent>
      <div className="card-wrapper">
        <img
          src={LoginTopImage}
          alt="Logo"
          width={448}
          style={{ position: "relative", right: 32 }}
        />
        <div className="banner-wrapper">
          <p>
            <b>Welcome Back</b>
          </p>
          <p>Sign in to continue</p>
        </div>

        <Form onFinish={handleLogin} validateTrigger="onFinish">
          <h4 className="form-label">Email</h4>
          <Form.Item name="Email" rules={[{ type: "email", required: true }]}>
            <InputWrapper
              label="Email"
              name="email"
              value={state.email}
              placeholder="abc@xyz.com"
              onChange={handleChange}
            />
          </Form.Item>

          <h4 className="form-label">Password</h4>
          <Form.Item name="Password" rules={[{ type: "string", required: true, min: 6 }]}>
            <InputWrapper.Password
              name="password"
              value={state.password}
              placeholder="Password"
              onChange={handleChange}
            />
          </Form.Item>

          <div style={{ margin: "24px 0", textAlign: "left" }}>
            <StyledCheckbox>Remember me</StyledCheckbox>
          </div>

          <ButtonWrapper size="large" htmlType="submit">
            Login
          </ButtonWrapper>
        </Form>

        {/* <div className="forgot-password">
          <Link to="/forgotpassword">
            <LockFilled /> Forgot Password
          </Link>
        </div> */}
      </div>
    </StyledContent>
  );
};

export default LoginNew;
